import loadView from "@/utils/load-view";

const routes = [
    {
        path: "/orgchart",
        name: "OrgChart",
        component: loadView("OrgChart"),
        meta: {
            authRequired: true,
            resolvers: [() => ({ type: "teams/current/getOrgChart" })],
        },
    },
];

export default routes;
